import { useTranslation } from 'react-i18next'

import { Alert, WarningOutlineIcon } from '@mercai/clever'

import { useCountdown } from '@/helpers'

export const CountdownOldScreen = () => {
  const { t } = useTranslation('componentsCountdownOldScreen')

  const { days, hours, minutes, seconds } = useCountdown(
    '2025-05-05T23:59:59.000Z',
  )

  const countdown = `${days}d ${hours}h ${minutes}m ${seconds}s`

  return (
    <Alert
      leftIcon={<WarningOutlineIcon />}
      variant="warning"
      title={`${t('title')}
          ${countdown}`}
    >
      {t('description')}
    </Alert>
  )
}
